//------------ IMPORTAÇÕES ------------//
import { useContext } from "react";
import { GruposContext } from "../../context/GruposContext";
import { createGroupService, loadGroupsService, synchronizeProductService } from "../../services";



//------------ EXPORTAÇÃO DO MODAL CREATE GROUP ------------//
export default function ModalCreateGroup() {



  //------------ CRIAÇÃO DE HOOKS ------------//
  const { isOpenModalCreateGroup, setIsOpenModalCreateGroup } = useContext(GruposContext);
  const { groupName, setGroupName } = useContext(GruposContext);
  const { products, setProducts } = useContext(GruposContext);
  const { idsProductsSelected, setIdsProductsSelected } = useContext(GruposContext);
  const { productSearched, setProductSearched } = useContext(GruposContext);
  const { groups, setGroups } = useContext(GruposContext);



  //--------------- FUNÇÃO ASSÍNCRONA SALVAR GRUPO ---------------//
  // Responsável por Salvar o Novo Grupo via API
  const handleCreateGroup = async () => {
    const response = await createGroupService(groupName);
    if (response) {
      const group = response.data;
      for (let productId of idsProductsSelected) {
        await synchronizeProductService(group.id, productId);
      }
      setGroupName("");
      setIdsProductsSelected([]);
      setProductSearched("");
      handleRefreshGroups();
      setIsOpenModalCreateGroup(false);
    }
  };



  //--------------- FUNÇÃO ASSÍNCRONA CARREGAR GRUPOS ---------------//
  // Responsável por requisitar à API os Grupos existentes
  // Armazena no Estado "grupos" a lista de Grupos retornada pela API
  async function handleRefreshGroups() {
    const response = await loadGroupsService();
    if (response) {
      setGroups(response.data);
    }
  }



  //--------------- FUNÇÃO TOGGLE PRODUTO ---------------//
  // Responsável por armazena no Estado "selectedIds" os IDs dos produtos selecionados pelo usário para compor o novo grupo
  // Quando um usuário marca um produto, a função "toggleProduto" armazena o ID no "selectIds", quando o usuário desmarca o produto, a função retira o ID do "selectIds"
  const toggleProduct = (id) => {
    setIdsProductsSelected(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };




  //--------------- RETORNO CONDICIONAL DO MODAL CREATE LEAD ---------------//
  return (
    <>
      {!isOpenModalCreateGroup
        ? null
        :
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-surface-2 p-6 rounded-xl w-full max-w-lg border border-white/[0.08]">
              <h2 className="text-xl font-bold mb-4">
                Novo Grupo
              </h2>
              <input
                type="text"
                placeholder="Nome do Grupo"
                value={groupName}
                onChange={e => setGroupName(e.target.value)}
                className="w-full mb-4 p-3 bg-surface-1 border border-white/[0.08] rounded"
              />
              <input
                type="text"
                placeholder="Buscar produto..."
                className="w-full px-3 py-2 rounded bg-surface-2 text-white border border-white/[0.08] mb-3"
                value={productSearched}
                onChange={(e) => setProductSearched(e.target.value)}
              />

              <div className="overflow-y-auto max-h-60 border border-white/[0.08] rounded bg-surface-2 text-white">
                {products
                  .filter(p =>
                    p.nome.toLowerCase().includes(productSearched.toLowerCase())
                  )
                  .map((product) => (
                    <label key={product.id} className="flex items-center gap-2 px-4 py-2 hover:bg-surface-3">
                      <input
                        type="checkbox"
                        checked={idsProductsSelected.includes(product.id)}
                        onChange={() => toggleProduct(product.id)}
                      />
                      {product.nome} (Hotmart ID: {product.id_produto_hotmart})
                    </label>
                  ))}
              </div>

              <div className="flex justify-end gap-2">
                <button onClick={() => setIsOpenModalCreateGroup(false)} className="bg-surface-3 px-4 py-2 rounded">Cancelar</button>
                <button onClick={handleCreateGroup} className="bg-green-600 px-4 py-2 rounded">Salvar</button>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}
